// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

// Import Material UI
import { Button, Dialog, DialogTitle, DialogActions, TextField } from "@material-ui/core/";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/styles";

// Import Pages
import ActionService from "./../../../../services/ActionService/ActionService";
import { alertState, personalizationState } from "../../../../recoil-store/recoil-state";

// Import CSS
import "./EditAction.css";

const EditAction = ({ id, actionName, library_version_id, closeModal }) => {
    const [name, setName] = useState("");
    const setAlert = useSetRecoilState(alertState);

    const { t } = useTranslation();

    useEffect(() => {
        setName(actionName)
    }, [])

    const handleClose = () => {
        closeModal(false)
    }

    const handleSave = async () => {
        if (!name) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY.ACTION-NAME-REQUIRED"),
                severity: 'error'
            }));
            return;
        }
        const result = await ActionService.renameCustomAction(id, { name, library_version_id });
        if (result) {
            if (result.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY.RENAME-SUCCESSFULLY"),
                    severity: 'success'
                }));
                closeModal(true, name);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY." + result.message),
                    severity: 'error'
                }));
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }));
        }
    }

    return (
        <Dialog
            id="autommate-modal"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden",
                    minWidth: 400,
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    <b>{t('CONTENT.LIBRARIES.RENAME-ACTION')}</b>
                    <Button>
                        <Close onClick={handleClose} />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent className="rename-dialog-content" >
                <div>

                    <span className="dialog-text">{t('CONTENT.LIBRARIES.ACTION-NAME')}<span className="mandatory-field">*</span> </span>
                    <TextField
                        id="filled-size-small"
                        required
                        className="rename-input-text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ style: { fontSize: 12 } }}
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />

                </div>
            </DialogContent>
            <DialogActions className="rename-dialog-action" >
                <button className="rename-update-button" onClick={handleSave} >
                    {t('CONTENT.LIBRARIES.UPDATE')}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default EditAction;